import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NoticeItem extends Component {

    render() {
        const { no, board, boardInfo} = this.props;
        const { title } = board;
                    
        return (
            <>
                <tr className="contents-item">
                    <td className="text-align-center">{no}</td>
                    <td className="text-align-left padding-l10 contents-item-title">{title}</td>
                    <td className="text-align-center">
                        <Link to={{ pathname: "/noticeMod", state: { board: board, boardInfo: boardInfo } }} >
                            <button className="button w76-button gray-button" name="수정">수정</button>
                        </Link>
                    </td>
                </tr>
            </>
        );
    }
}

export default (NoticeItem);